import React from 'react';
import {Form, Input, Upload, Button, message} from 'antd';
import {PictureOutlined} from '@ant-design/icons';
import 'braft-editor/dist/index.css';
import BraftEditor from 'braft-editor';
import { ContentUtils } from 'braft-utils';
import {api, fileUpload} from "../../request";

export default class QaForm extends React.Component{

    static STATE_STRUCT = (content) => {
        return {
            editorState: BraftEditor.createEditorState(content ? content : null),
            editorImageDisable: false,
        }
    };

    state = QaForm.STATE_STRUCT(this.props.defaultFormValue ? this.props.defaultFormValue.content : null);

    render() {
        const finish = values => {
            if (!values.title){
                message.error("请填写Qa标题!");
            } else if (!values.pageTitle){
                message.error("请填写Qa页面标题!");
            } else if (!values.meta){
                message.error("请填写Qa meta!");
            } else if (!values.desc){
                message.error("请填写Qa简介!");
            } else if (this.state.editorState.isEmpty()){
                message.error("请填写Qa内容!");
            } else{
                if (this.props.onUpload){
                    this.props.onUpload({
                        title: values.title,
                        desc: values.desc,
                        pageTitle: values.pageTitle,
                        meta: values.meta,
                        content: this.state.editorState.toHTML(),
                    });
                }
            }
        };

        const excludeControls = [
            'media'
        ];

        const extendControls = [
            {
                key: 'antd-uploader',
                type: 'component',
                component: (
                    <Upload
                        accept="image/*"
                        showUploadList={false}
                        disabled={this.state.editorImageDisable}
                        beforeUpload={(file)=>{
                            if (file.size > (2 * 1024 * 1024)){
                                message.error('文件最大2m');
                                return false;
                            }

                            this.setState({editorImageDisable: true});
                            fileUpload(api.addImage, file, (res) => {
                                this.setState({editorImageDisable: false});
                                if (res.code === 200){
                                    this.setState({
                                        editorState: ContentUtils.insertMedias(this.state.editorState, [{
                                            type: 'IMAGE',
                                            url: api.getImage(res.data),
                                        }])
                                    });
                                }
                            });
                            return false;
                        }}
                    >
                        <Button className="control-item button upload-button" data-title="插入图片">
                            <PictureOutlined />
                        </Button>
                    </Upload>
                )
            }
        ];

        console.log(this.props.defaultFormValue);

        return (
            <Form name="newsForm" onFinish={finish}
                  initialValues={{
                      ['title'] : this.props.defaultFormValue ? this.props.defaultFormValue.title : '',
                      ['desc'] : this.props.defaultFormValue ? this.props.defaultFormValue.desc : '',
                      ['pageTitle'] : this.props.defaultFormValue? this.props.defaultFormValue.pageTitle : '',
                      ['meta'] : this.props.defaultFormValue? this.props.defaultFormValue.meta : '',
                  }}>
                <Form.Item
                    label="Qa标题"
                    name="title"
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="页面标题"
                    name="pageTitle"
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="页面Meta"
                    name="meta"
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Qa简介"
                    name="desc"
                >
                    <Input.TextArea />
                </Form.Item>
                <label style={{height: 14, color: "black", fontSize: 14}}>Qa内容:</label>
                <BraftEditor
                    value={this.state.editorState}
                    onChange={(editorState)=> this.setState({editorState: editorState})}
                    style={{borderWidth: 1, borderStyle: "solid", borderColor: "#d9d9d9"}}
                    excludeControls={excludeControls}
                    extendControls={extendControls}
                    placeholder="请输入Qa内容"
                />
                <Form.Item>
                    <Button type="primary" htmlType="submit" style={{marginTop: 20}} loading={this.props.loading}>
                        {this.props.defaultFormValue ? '更新Qa' : '增加Qa'}
                    </Button>
                </Form.Item>
            </Form>
        );
    }
}
